import axios from "axios";

const apiBackoffice = axios.create({
  baseURL: process.env.REACT_APP_API_URL_BACKOFFICE,
});

export default apiBackoffice;
